import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { t } from '@insight/toolkit-utils/lib/labels';

import HeaderContext from './HeaderContext';
import HeaderSearchSuggestion from './HeaderSearchSuggestion';

const HeaderSearchSuggestions = ({
  onSelect,
  query,
  removeSuggestion,
  suggestions,
}) => {
  const { isSearchActive, isSuggestionsActive, setSuggestionsActive } =
    useContext(HeaderContext);

  /**
   * When either the suggestions change, or the search bar is activated (or
   * deactivated) then update the `isSuggestionsActive` flag accordingly.
   */
  useEffect(() => {
    setSuggestionsActive(isSearchActive && suggestions && suggestions.length);
  }, [suggestions, isSearchActive]);

  return (
    <div
      className={`c-header-search-suggestions  ${isSuggestionsActive ? 'is-visible' : ''}`}
    >
      <ul
        className="o-list-bare  c-header-search-suggestions__list"
        aria-label={t('Search suggestions')}
      >
        {suggestions &&
          suggestions.map((suggestion, index) => (
            <HeaderSearchSuggestion
              key={index}
              onSelect={onSelect}
              query={query}
              removeSuggestion={removeSuggestion}
              suggestion={suggestion}
            />
          ))}
      </ul>
    </div>
  );
};

export default HeaderSearchSuggestions;

HeaderSearchSuggestions.propTypes = {
  onSelect: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  removeSuggestion: PropTypes.func,
  suggestions: PropTypes.arrayOf(PropTypes.object),
};

HeaderSearchSuggestions.defaultProps = {
  removeSuggestion: null,
  suggestions: null,
};
